import React, { useState } from "react";
import { NoticeLayout } from "../Components/NoticeLayout";
import { NoticeToolBar } from "../Components/NoticeToolBar";
import NoticeItem from "./Components/NoticeItem";
import useRequest, { errorMessage } from "../../../Utils/useRequest";
import {
    busiMessageClearRead,
    busiMessageList,
    busiMessageReadAll
} from "../../../API";
import { message, Modal, Spin } from "antd";
import CustomEmpty from "../../../components/CustomEmpty";
import { SystemMsgCountAtom } from "../../../Stores/CommonStore";
import { useAtomValue } from "jotai";
import { useUpdateNoticeCount } from "../../../Utils/useUpdateNoticeCount";

export function SystemMsgList() {
    const updateCount = useUpdateNoticeCount();
    const unreadNum = useAtomValue(SystemMsgCountAtom);

    const [unread, setUnread] = useState(false);

    // 获取数据
    const [data, { loading }, refresh] = useRequest(
        async () => {
            updateCount();
            return await busiMessageList(unread);
        },
        {},
        [unread]
    );

    // 标记所有为已读
    async function markReadAll() {
        try {
            await busiMessageReadAll();
            await refresh();
            updateCount();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    // 清除已读
    async function clearReadAll() {
        Modal.confirm({
            content: "确定要删除所有已读消息吗?",
            onOk: async () => {
                try {
                    await busiMessageClearRead();
                    await refresh();
                    updateCount();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    }

    return (
        <NoticeLayout tab="system">
            <NoticeToolBar
                viewUnread={() => setUnread(!unread)}
                clearReadAll={clearReadAll}
                markReadAll={markReadAll}
                unreadNum={unreadNum}
            />

            <Spin spinning={loading}>
                {data?.map(item => (
                    <NoticeItem key={item.uuid} data={item} />
                ))}

                {(!data || data.length === 0) && (
                    <CustomEmpty style={{ padding: "50px 0" }} />
                )}
            </Spin>
        </NoticeLayout>
    );
}
